import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { MatTooltipTruncateModule } from '@y42/core/mat-tooltip-truncate';
import { OpenInAssetSidebarButtonModule } from '../../asset-sidebar';
import { FeatureTypeChildIconModule } from '../../feature-type-child-icon';
import { SubEntryCellRendererComponent } from './sub-entry-cell-renderer.component';

@NgModule({
  declarations: [SubEntryCellRendererComponent],
  imports: [
    CommonModule,
    OpenInAssetSidebarButtonModule,
    MatTooltipModule,
    MatTooltipTruncateModule,
    FontAwesomeModule,
    FeatureTypeChildIconModule,
  ],
  exports: [SubEntryCellRendererComponent],
})
export class SubEntryCellRendererModule {}
